import router from '@/router'
// import { advertisementTime } from "@/api/newerpapi.js";

export default function () {
//     let advertisementTimeVal = null;
//   advertisementTime().then(res=>{
//     console.log(res.data.data.configValue);
//     advertisementTimeVal=res.data.data.configValue;
    
//   });
//   alert(advertisementTimeVal)
    let setInterval = null;//定时器
    let timeOut = 60 * 1000 // 设置超时时间: 10秒钟
    
    // console.log("开始", new Date().getTime())
    // 初次向sessionStorage存入操作时间
    window.sessionStorage.setItem('lastTime', new Date().getTime())
    // 每次操作页面，更新sessionStorage存入的操作时间
    window.onload = function () {
        window.document.onmousedown = function () {
            // console.log("开始", new Date().getTime())
            window.sessionStorage.setItem('lastTime', new Date().getTime())
        }
    }
    function checkTimeout() {
        
        let currentTime = new Date().getTime() // 当前时间
        let lastTime = window.sessionStorage.getItem("lastTime")//上次操作的时间
        // 判断是否超时
        if (currentTime - lastTime >= timeOut) {
            // console.log("结束", new Date().getTime())
            // 清除定时器
            window.clearInterval(setInterval);
            // 清除sessionStorage
            // window.sessionStorage.clear('lastTime')
            // 跳到登陆页
            if (router.history.current.fullPath != '/advertisementInfor' && router.history.current.fullPath !== '/login' && router.history.current.fullPath !== '/' && router.history.current.fullPath !== '/OrderingInfor'&& router.history.current.fullPath !== '/constructionSite') {
                router.push({ path: '/advertisementInfor', query: { selected: router.history.current.fullPath } })
                // window.location.reload()   
            }
            console.log(new Date(), router.history.current.fullPath)
        }
    }
    /* 定时器 间隔2秒检测是否长时间未操作页面 */
    setInterval = window.setInterval(checkTimeout, 2000)
    
}